'use client'

import { Box, Spinner, Text, VStack } from '@chakra-ui/react'

interface LoadingStateProps {
  message?: string
}

export function LoadingState({ message = 'Loading...' }: LoadingStateProps) {
  return (
    <Box 
      display="flex" 
      alignItems="center" 
      justifyContent="center" 
      minH="400px"
      w="full"
    >
      <VStack gap={4}>
        <Spinner size="xl" color="primary.500" />
        <Text color="gray.400">{message}</Text>
      </VStack>
    </Box>
  )
}